// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"8fd2bb4f","433":"acd484f7","453":"e21e234d"}[chunkId] + ".chunk.js";
};